import { Inject } from '@angular/core';
import { WINDOW } from '@ng-web-apis/common';

import { environment as admin } from 'apps/admin-web/src/environments/environment';
import { environment as account } from 'apps/account-web/src/environments/environment';
import { environment as onboarding } from 'apps/onboarding-web/src/environments/environment';
import { environment as backoffice } from 'apps/backoffice-web/src/environments/environment';

export class ApplicationChecker {

  constructor(
    @Inject(WINDOW) public window: any
  ) { }

  private get adminWebPaths(): string[] {
    return [
      admin.fitscoveryApps.adminUrl,
      'https://preview-admin.fitscovery.com/',
      'https://dev-admin-ng-fitscovery.web.app/'
    ];
  }

  private get onboardingWebPaths(): string[] {
    return [
      onboarding.fitscoveryApps.onboardingUrl,
      'https://dev-onboarding-fitscovery.web.app/',
      'https://dev-onboarding-fitscovery.firebaseapp.com/'
    ];
  }

  private get baseURL(): string {
    return this.window.location.origin;
  }

  get isPartnerWeb(): boolean {
    return !this?.isAdminWeb && !this?.isAccountWeb && !this?.isOnboardingWeb && !this?.isBackOfficeWeb;
  }

  get isAdminWeb(): boolean {
    const localPath = 'http://localhost:4203';
    const deploymentPaths = this.adminWebPaths;
    const pathCheck = deploymentPaths.includes(this.baseURL);
    const localPathCheck = this.baseURL.includes(localPath);
    return pathCheck || localPathCheck;
  }

  get isAccountWeb(): boolean {
    const localPath = 'http://localhost:4204';
    const pathCheck = this.baseURL.includes(localPath);
    return (this.baseURL === account.fitscoveryApps.accountUrl) || pathCheck;
  }

  get isOnboardingWeb(): boolean {
    const localPath = 'http://localhost:4205';
    const deploymentPaths = this.onboardingWebPaths;
    const pathCheck = deploymentPaths.includes(this.baseURL);
    const localPathCheck = this.baseURL.includes(localPath);
    return pathCheck || localPathCheck;
  }

  get isBackOfficeWeb(): boolean {
    const localPath = 'http://localhost:4206';
    const pathCheck = this.baseURL.includes(localPath);
    return (this.baseURL === backoffice.fitscoveryApps.backofficeUrl) || pathCheck;
  }
  
}
